import React from 'react';
import TeamSection from './Team/TeamSection';
import MeetUs from './MeetUs/MeetUs';
import WhoWeAre from './Team/Whoweare/WhoWeAre';
import OurProjects from '../HomePage/OurProjects/OurProjects.jsx';
import  {useEffect,} from "react";
import { Helmet } from 'react-helmet';

const OurTeamPage = () => {
     useEffect(() => {
    window.scrollTo(0, 0);
    // setVisible(true);
  }, []);
  
    return (
        <div>
          
           <Helmet>
                  <title>Ultimates Roofing LLC-Our Team </title>
                  <link rel="canonical" href="/our-team" />
                  <meta
                    name="description"
                    content="Our  team's roofing protects communities with pride, purpose, and precision delivering durable, high-quality craftsmanship you can trust."
                  />
                  <meta
                    name="keywords"
                    content="Ultimates Roofing llc, Ultimates Roofing, Best Roofing design in columbus,ohio, Best Roofing Companies in columbus ohio, ultimates roof replacement near me, best roofing designs for small houses, best roofing drip edge, best roof columbus, best roofing company near me, ultimates roof replacement columbus ohio, 
                          best roofing company, ultimates roof repair columbus ohio, affordable roof, eplacement services in columbus,ohio, luxury home roofing solutions near me, roof repair, Roofer near me, roofing repairs near me, roofing sheet"
                  />
                  <meta name="author" content="Ultimates Roofing LLC" />
                  <meta name="robots" content="index, follow" />
                  <html lang="en" />
            </Helmet>
            <MeetUs></MeetUs>
            <WhoWeAre></WhoWeAre>
           <TeamSection></TeamSection>
           <OurProjects></OurProjects>
        </div>
    );
};

export default OurTeamPage;